export default __webpack_public_path__ + "static/media/phone_icon.977275f9.svg";